import { NgModule} from '@angular/core';
import { CacheService } from './services/cache.service';

@NgModule({
    providers: [ CacheService ]
})
export class Ng2CacheModule {}
